const BASE_BOTTOM = 20;
const FAB_SIZE = 40;
const GAP = 12;

export const touchEditToggleButtonStyles = {
	root: (scrollUpVisible: boolean) => ({
		display: 'none',
		position: 'fixed',
		bottom: scrollUpVisible ? BASE_BOTTOM + FAB_SIZE + GAP : BASE_BOTTOM,
		right: 20,
		transition: 'bottom 200ms ease-in-out',
		'@media (hover: none)': {
			display: 'inline-flex'
		}
	})
};
